import { PropsWithChildren } from "react";

type ContentBlockButtonProps = PropsWithChildren<{
    className?: string;
}> &
    Record<`data-${string}`, any>;

export const ContentBlockButton = ({
    className,
    children,
    ...dataAttributes
}: ContentBlockButtonProps) => (
    <article>
        <button
            className={className}
            {...dataAttributes}
        >
            {children}
        </button>
    </article>
);
